import gql from 'graphql-tag';

export const PAUSE_SUBSCRIPTION_MUTATION = gql`
  mutation pauseSubscription($input: PauseSubscriptionInput!) {
    pauseSubscription(input: $input) {
      errors {
        message
        type
      }
    }
  }
`;
